import React from 'react';
import Page from './Page';

export default ({match: {params}}) => {
    return (
        <Page slug={params.slug} />
    );
};

